<script>
import axios from "axios";
import SaveInfo from "./Base/SaveInfo";
import BaseInput from "./Base/BaseInput3";
import BaseOneChoiseCheckbox from "./Base/BaseOneChoiseCheckbox";
import BaseInput3Num from "./Base/BaseInput3Num";
import BaseTextarea from "./Base/BaseTextarea";
import BaseLocation from "./Base/BaseLocation3";
import moment from "moment/moment";
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faEdit, faTrash, faQuestion} from '@fortawesome/free-solid-svg-icons';
import 'ant-design-vue/dist/antd.css';
import {Modal, DatePicker} from 'ant-design-vue';
import DropzoneComponent from "./Base/DropzoneComponent";
import {v4 as uuidv4} from 'uuid';
import locale from "ant-design-vue/es/date-picker/locale/ru_RU"
import 'moment/locale/ru';

moment.locale("ru")
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import 'dayjs/locale/ru';

dayjs.extend(isBetween);
dayjs.locale('ru');

library.add(faEdit);
library.add(faTrash);
library.add(faQuestion);

const item = {
	firm_name: '',
	area_name: '',
	area_address: '',
	country: '',
	isSelo: false,
	city: '',
	poselok: '',
	social: '',
	region: '',
	phone: '',
	status: '',
	email: '',
	hall_num: 0,
	coordinator_comment: '',
	shows: []
}

export default {
	name: 'Area2Component',
	props: {
		thisYearDate1: {
			type: String,
			required: true
		},
		thisYearDate2: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			area2: structuredClone(item),
			current_show: null,
			isSelo: true,
			show_date: null,
			show_programm: '',
			show_is_online: false,
			isLoading: true,
			isSubmitted: false,
			isDataUpdating: false,
			datetime: new Date(),
			citiestoinput: '',
			country: 'Российская Федерация',
			type_datetime: '',
			errors: [],
			isPhotoUpload: false,
			isScreenUpload: false,
			validationRules: [
				{
					fieldName: 'area_name',
					isRequired: true,
					entity: 'area2',
					errorText: 'Поле "Наименование площадки" обязательно для заполнения'
				},
				{
					fieldName: 'area_address',
					isRequired: true,
					entity: 'area2',
					errorText: 'Поле "Адрес площадки" обязательно для заполнения'
				},
				{
					fieldName: 'social',
					isRequired: true,
					entity: 'area2',
					errorText: 'Поле "Соц. сеть площадки" обязательно для заполнения'
				},
				{
					fieldName: 'hall_num',
					isRequired: true,
					entity: 'area2',
					errorText: 'Поле "Общее количество мест" обязательно для заполнения'
				},
				{
					fieldName: 'city',
					isRequired: true,
					entity: 'area2',
					errorText: 'Поле "Город" обязательно для заполнения'
				},
				{
					fieldName: 'poselok',
					isRequired: true,
					entity: 'area2',
					errorText: 'Поле "Поселок (село)" обязательно для заполнения'
				},
				{
					fieldName: 'region',
					isRequired: true,
					entity: 'area2',
					errorText: 'Поле "Регион" обязательно для заполнения'
				},
				{
					fieldName: 'country',
					isRequired: true,
					entity: 'area2',
					errorText: 'Поле "Страна" обязательно для заполнения'
				}
			],
			countriesinput: [],// Список стран для отображения.
			locale: locale
		}
	},
	components: {
		SaveInfo,
		BaseInput,
		BaseTextarea,
		BaseInput3Num,
		DatePicker,
		BaseLocation,
		FontAwesomeIcon,
		//SearchAutocompleteCities,
		BaseOneChoiseCheckbox,
		Modal,
		DropzoneComponent
		//SearchAutocomplete
	},
	mounted: function () {
		
		if (this.isInterantional) {
			this.validationRules.push(
				{
					fieldName: 'email',
					isRequired: true,
					entity: 'area2',
					errorText: 'Поле "E-mail площадки" обязательно для заполнения'
				},
				{
					fieldName: 'phone',
					isRequired: true,
					entity: 'area2',
					errorText: 'Поле "Телефон для связи" обязательно для заполнения'
				},
			)
		}
		this.getData();
	},
	methods: {
		async getData() {
			this.isLoading = true;
			if (this.countriesinput.length === 0) {
				await this.loadCountries();
			}
			if (this.area2id) {
				const areaResponse = await axios.get('/api/area2levels/' + this.area2id, {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					}
				});
				
				if (Object.keys(areaResponse.data.data).length > 0) {
					this.area2 = areaResponse.data.data;
				} else {
					this.area2 = structuredClone(item);
				}
				
				if (!this.area2?.isSelo) {
					this.area2.isSelo = false;
				}
				// Преобразуем даты только если shows существует и не пустой
				if (this.area2.shows && this.area2.shows.length > 0) {
					this.area2.shows = this.area2.shows.map((value) => ({
						...value,
						date: value.date ? dayjs(value.date) : null
					}));
				}
				
				const current_cuntry = this.countriesinput.find(el => el.ru_name === this.area2.country);
				if (current_cuntry?.number) {
					this.country = current_cuntry.number
				}
				// if (this.citiestoinput.length === 0) {
				//   this.loadCities();
				// }
			} else {
				this.area2 = structuredClone(item)
			}
			
			this.$nextTick(() => {
				setTimeout(() => {
					this.isLoading = false;
				}, 500);
			});
		},
		saveData() {
			if (window.area2id) {
				this.checkErrors(false);
				if (this.errors.length === 0) {
					this.isDataUpdating = true;
					
					console.log(this.area2);
					
					axios.patch('/api/area2levels/' + window.area2id,
						{
							'data': this.area2
						},
						{
							headers: {
								'Accept': 'application/json',
								'Content-Type': 'application/merge-patch+json',
							}
						}
					).then(() => {
						this.getData();
						this.isDataUpdating = false;
					}).catch(error => {
						console.log(error);
						alert('Ошибка получения данных')
					});
				}
				
			} else {
				if (this.isSubmitted) {
					this.checkErrors(false);
					if (this.errors.length === 0) {
						axios.post('/area2/new', null, {
							params: {
								area: this.area2,
								userid: window.userid
							}
						}).then(() => {
							location.reload();
						}).catch(error => {
							alert('Ошибка получения данных');
							console.log(error.response.data);
						})
					}
				}
			}
		},
		updateShowDate(index, val) {
			this.area2.shows[index].date = val ? dayjs(val) : undefined;
			this.saveData();
		},
		isFieldRequired(fieldName) {
			let res = false;
			this.validationRules.forEach(function (field) {
				if (
					(field.fieldName === fieldName || field?.altFieldName === fieldName)
					&& field.isRequired) {
					res = true;
				}
			});
			return res;
		},
		validateField(field) {
			const self = this;
			if (
				field.isRequired && (self[field.entity][field.fieldName] === null || !self[field.entity][field.fieldName] || self[field.entity][field.fieldName]?.length === 0 || self[field.entity][field.fieldName] === false || self[field.entity][field.fieldName] === 0)) {
				if (!self.errors.find(x => x.text === field.errorText)) {
					self.errors.push({
						text: field.errorText,
						order: field.order ? field.order : '1'
					});
				}
			}
		},
		checkErrors(withScroll = true) {
			const self = this;
			self.errors = [];
			
			const index = this.validationRules.findIndex(object => {
				return object.fieldName === 'city';
			});
			
			const indexCountry = this.validationRules.findIndex(object => {
				return object.fieldName === 'country';
			});
			
			const indexSelo = this.validationRules.findIndex(object => {
				return object.fieldName === 'poselok';
			});
			
			if (this.userid !== '6959') {
				this.validationRules[indexCountry].isRequired = false;
			}
			
			if (this['area2'].isSelo) {
				this.validationRules[index].isRequired = false;
				this.validationRules[indexSelo].isRequired = true;
			} else {
				this.validationRules[index].isRequired = true;
				this.validationRules[indexSelo].isRequired = false;
			}
			
			this.validationRules.forEach(function (field) {
				self.validateField(field)
			});
			
			if (this.errors.length > 0) {
				if (withScroll) {
					document.getElementById("main_block2").scrollIntoView();
				}
			}
		},
		async loadCountries() {
			const response = await axios.get('/get_all_countries', {
				headers: {
					'Accept': 'application/json',
				}
			})
				.catch(error => {
					console.log(error);
				});
			this.countriesinput = response.data;
		},
		async loadCities() {
			let url = '/get_world_cities';
			if (this.country !== 'RU') {
				url = '/get_world_cities/' + this.country;
			}
			await axios.get(url, {
				headers: {
					'Accept': 'application/json',
				}
			}).then((response) => {
				this.citiestoinput = response.data;
			}).catch(error => {
				console.log(error);
			});
		},
		getTranslation(phrase) {
			let res;
			if (this.lang === 'en') {
				res = this.translations[phrase];
			} else {
				res = phrase;
			}
			return res;
		},
		setRegion() {
		},
		async addDateTime() {
			if (!this.show_programm || !this.show_date_formated) {
				alert('Выберите программу и ее дату и время');
				return;
			}
			if (this.area2.shows !== undefined && this.area2?.shows?.filter(e => e.date === moment(this.show_date_formated).format('YYYY-M-D HH:mm')).length > 0) {
				alert('Эта дата уже добавлена.');
				return
			}
			if (this.area2.shows === undefined || this.area2.shows === null) {
				this.area2.shows = [];
			}
			
			this.area2.shows.push({
				'date': this.show_date_formated,
				'show_programm': this.show_programm,
				'show_is_online': this.show_is_online
			});
			this.saveData();
			this.show_date = null;
			this.show_programm = '';
			this.show_is_online = false;
		},
		async deleteDatetime(index) {
			//const index = this.area2.releasesDates.indexOf(item);
			if (index > -1) {
				this.area2.shows.splice(index, 1);
			}
			this.saveData();
		},
		containsObject(obj, list) {
			var i;
			
			for (i = 0; i < list.length; i++) {
				if (list[i].date == obj.date && list[i].type_datetime == obj.type_datetime) {
					return true;
				}
			}
			
			return false;
		},
		getDateFromDate(date) {
			return moment(date).format("YYYY-MM-DD");
		},
		getTimeFromDate(date) {
			return moment(date).format("HH:ii");
		},
		async uploadPhotoHandler(index) {
			let need_save = false;
			if (!this.area2.shows[index].uuid) {
				this.area2.shows[index].uuid = uuidv4();
				need_save = true;
			}
			if (need_save) {
				await this.saveData();
			}
			this.isPhotoUpload = true;
			this.current_show = this.area2.shows[index]
		},
		async uploadScreenHandler(index) {
			let need_save = false;
			if (!this.area2.shows[index].uuid) {
				this.area2.shows[index].uuid = uuidv4();
				need_save = true;
			}
			if (need_save) {
				await this.saveData();
			}
			this.isScreenUpload = true;
			this.current_show = this.area2.shows[index]
		},
		getMomentDate(date) {
			return moment(date);
		},
		getDateYear(date) {
			return date.year();
		},
		isDateShowInRange(date) {
			const dateToCheck = dayjs.isDayjs(date) ? date : dayjs(date);
			const startDate = dayjs(this.thisYearDate1);
			const endDate = dayjs(this.thisYearDate2);
			
			return dateToCheck.isBetween(startDate, endDate, null, '[]');
		},
		isAreaHasShowWithName(name) {
			let res = false;
			if (this.area2 && this.area2.shows) {
				this.area2.shows.forEach((show) => {
					if (show.show_programm == name) {
						res = true;
					}
				});
			}
			return res;
		},
		showDate(index) {
			if (!this.area2 || !Array.isArray(this.area2.shows)) {
				return undefined;
			}
			const date = this.area2.shows[index]?.date;
			if (!date || !dayjs(date).isValid()) {
				return undefined;
			}
			return date;
		},
	},
	computed: {
		show_date_formated() {
			if (!this.show_date) {
				return null;
			}
			return dayjs(this.show_date).second(0)
		},
		isInterantional() {
			return this.userid === '6959' || (this.areaCountry !== 'Российская Федерация' && this.areaCountry.length > 0);
		},
		areaCountry() {
			return window.area_country;
		},
		isSNGArea() {
			let res = false;
			if (this.area2?.country && (this.area2.country === 'Казахстан' || this.area2.country === 'Азербайджан' || this.area2.country === 'Армения' || this.area2.country === 'Беларусь' || this.area2.country === 'Кыргызстан' || this.area2.country === 'Молдова' || this.area2.country === 'Таджикистан' || this.area2.country === 'Узбекистан')) {
				res = true;
			}
			return res;
		},
		
		area2id() {
			return window.area2id;
		},
		userid() {
			return window.userid;
		},
		isCoordinator() {
			return window.is_coordinator;
		},
		isAdmin() {
			return window.currentUserRoles.includes('ROLE_ADMIN')
		},
		uniqShows() {
			if (this.area2?.shows) {
				return [...new Set(this.area2.shows.map(item => item.show_programm))]
			}
			return [];
		}
	},
	watch: {}
}
</script>

<template>
	<div>
		<SaveInfo
			:isDataUpdating="isDataUpdating"
		></SaveInfo>
		<div id="main_block2">
			<div class="errors-block" v-if="errors.length">
				<b>Пожалуйста, заполните поля:</b>
				<ul>
					<li v-for="(error,index) in errors" :key="index" v-html="error.text"></li>
				</ul>
			</div>
			
			
			<div v-if="area2?.shows?.length>0"
			     style="font-size: 15px; border: 2px solid #F69F22; padding: 10px; margin-top: 15px; margin-bottom: 30px;">
				<p style="margin-bottom: 0; font-weight: bold">Если показ был проведен, просим заполнить отчет:
					количество зрителей на показе,
					ссылки на релизы, скриншоты релизов и фотографии с показа.</p>
			</div>
			
			<div class="columns">
				<div class="column">
					<BaseInput
						label="Название площадки (укажите место, где пройдет показ)"
						description="название кинотеатра/Дома культуры/библиотеки/ВУЗ/киношколы и т.д."
						objectKey="area_name"
						v-model="area2.area_name"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						@onChange="saveData"
					></BaseInput>
					
					<BaseInput
						label="Адрес площадки"
						description="(улица, строение, корпус)"
						objectKey="area_address"
						v-model="area2.area_address"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						@onChange="saveData"
					></BaseInput>
					
					<BaseInput
						label="Телефон для связи"
						objectKey="phone"
						v-model="area2.phone"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						@onChange="saveData"
					></BaseInput>
					
					<BaseInput
						label="E-mail площадки"
						objectKey="email"
						v-model="area2.email"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						@onChange="saveData"
					></BaseInput>
				
				</div>
				<div class="column">
					
					<BaseLocation
						parentObj="area2"
						fieldEntity="area2"
						:countriesinput="countriesinput"
						v-model:country="area2.country"
						v-model:city="area2.city"
						v-model:poselok="area2.poselok"
						v-model:region="area2.region"
						:isDataUpdating="isDataUpdating"
						v-model:isSelo="area2.isSelo"
						objectKey="country"
						:isSeloLabelId="'selo2'"
						labelCountry="Страна"
						labelCity="Город"
						labelRegion="Регион"
						labelSelo="Поселок (деревня)"
						countryKey="country"
						:isSubmitted="isSubmitted"
						:cityKey="'city'"
						regionKey="region"
					></BaseLocation>
					
					
					<BaseInput
						:label="getTranslation('Соц. сеть площадки (Instagram, Вконтакте, Facebook и т.д.) или сайт')"
						v-model="area2.social"
						objectKey="social"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						@onChange="saveData"
					></BaseInput>
					
					<BaseInput3Num
						:label="getTranslation('Количество зрительских мест')"
						v-model="area2.hall_num"
						objectKey="hall_num"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						@onChange="saveData"
					></BaseInput3Num>
					
					<template v-if="isCoordinator === '1'">
						<BaseTextarea
							label="Комментарий"
							v-model="area2.coordinator_comment"
							objectKey="coordinator_comment"
							:isDataUpdated="isDataUpdating"
							:isFormSubmitted="isSubmitted"
							@onChange="saveData"
						></BaseTextarea>
					</template>
				</div>
			</div>
			
			<template v-if="area2id">
				<h2 style="font-size: 23px;">Информация о показах</h2>
				
				<div style="display: flex; flex-wrap: wrap; margin-top: 50px; align-items: end;">
					<template v-if="area2.country !== 'Российская Федерация'">
						<template v-if="isAreaHasShowWithName('Нейросетевое кино')">
							<a class="mini_button" href="https://disk.yandex.ru/i/YHz8G7OaQOtdEg" target="_blank">AI-films, 35 min, 18+ - Высокое качество</a>
							<a class="mini_button" href="https://disk.yandex.ru/i/NTZOKVCOUtIlkA" target="_blank">AI-films, 35 min, 18+ - Быстрое скачивание</a>
						</template>
						
						<template v-if="isAreaHasShowWithName('Документальное кино: часть первая')">
							<a class="mini_button" href="https://disk.yandex.ru/i/8Wehabt98vGZSw" target="_blank">DOC, pt.1 78 min, 16+ - Высокое качество</a>
							<a class="mini_button" href="https://disk.yandex.ru/i/1BYIohkTOZT4iQ" target="_blank">DOC, pt.1, 78 min, 16+ - Быстрое скачивание</a>
						</template>
						
						<template v-if="isAreaHasShowWithName('Документальное кино: часть вторая')">
							<a class="mini_button" href="https://disk.yandex.ru/i/LqcUI2VX2EK2Mg" target="_blank">DOC, pt.2 81 min, 18+ - Высокое качество</a>
							<a class="mini_button" href="https://disk.yandex.ru/i/CewnvI1CeXuq_A" target="_blank">DOC, pt.2, 81 min, 18+ - Быстрое скачивание</a>
						</template>
						
						<template v-if="isAreaHasShowWithName('Возвращение домой. Игровое кино')">
							<a class="mini_button" href="https://disk.yandex.ru/i/KFRZyCeGrnKM7w" target="_blank">Homecoming, 87 min, 12+ - Высокое качество</a>
							<a class="mini_button" href="https://disk.yandex.ru/i/gSYrFfwYXZmFBg" target="_blank">Homecoming, 87 min, 12+ - Быстрое скачивание</a>
						</template>
						
						
						<template v-if="isAreaHasShowWithName('Шаг навстречу. Игровое кино')">
							<a class="mini_button" href="https://disk.yandex.ru/i/1TqqaZJDM07Tyg" target="_blank">Step Forward, 92 min, 18+ - Высокое качество</a>
							<a class="mini_button" href="https://disk.yandex.ru/i/n1ju-RWWXA7Mjg" target="_blank">Step Forward, 92 min, 18+ - Быстрое скачивание</a>
						</template>
						
						
						
						<template v-if="isAreaHasShowWithName('Суздальфест: часть первая 6+')">
							<a class="mini_button" href="https://disk.yandex.ru/i/t4FMqm_HA19Dcw" target="_blank">Suzdal-fest: pt.1, 76 min, 6+ (No subtitles) - Высокое качество</a>
							<a class="mini_button" href="https://disk.yandex.ru/i/Er977qJZ3C3IiQ" target="_blank">Suzdal-fest: pt.1, 76 min, 6+ (No subtitles) - Быстрое скачивание</a>
						</template>
						
						<template v-if="isAreaHasShowWithName('Суздальфест: часть вторая 6+')">
							<a class="mini_button" href="https://disk.yandex.ru/i/PwZUAUlKMyC2Sw" target="_blank">Suzdal-fest: pt.2, 65 min, 6+ (No subtitles) - Высокое качество</a>
							<a class="mini_button" href="https://disk.yandex.ru/i/fqnMwZVJGKkdvg" target="_blank">Suzdal-fest: pt.2, 65 min, 6+ (No subtitles) - Быстрое скачивание</a>
						</template>
						

						
					</template>
					<template v-else>
						<template v-if="isAreaHasShowWithName('Звёзды в коротком метре. Игровое кино')">
							<a class="mini_button" href="https://disk.yandex.ru/i/cbTVYsYXikZrlw" target="_blank">Звёзды в коротком метре, 101 мин, 18+ - Высокое качество</a>
							<a class="mini_button" href="https://disk.yandex.ru/i/O3RWQdiTcSJH3Q" target="_blank">Звёзды в коротком метре, 101 мин, 18+ - Быстрое скачивание</a>
						</template>
						<!-- Суздальфест: часть первая -->
						<template v-if="isAreaHasShowWithName('Суздальфест: часть первая 6+')">
							<a class="mini_button" href="https://disk.yandex.ru/i/t4FMqm_HA19Dcw" target="_blank">Суздальфест: часть первая, 76 мин, 6+ - Высокое качество</a>
							<a class="mini_button" href="https://disk.yandex.ru/i/Er977qJZ3C3IiQ" target="_blank">Суздальфест: часть первая, 76 мин, 6+ - Быстрое скачивание</a>
						</template>
						
						<!-- Суздальфест: часть вторая -->
						<template v-if="isAreaHasShowWithName('Суздальфест: часть вторая 6+')">
							<a class="mini_button" href="https://disk.yandex.ru/i/-yVw0r8HPXaTNA" target="_blank">Суздальфест: часть вторая, 65 мин, 6+ - Высокое качество</a>
							<a class="mini_button" href="https://disk.yandex.ru/i/lb0lyLK0DVQA9Q" target="_blank">Суздальфест: часть вторая, 65 мин, 6+ - Быстрое скачивание</a>
						</template>
						
						<!-- Нейросетевое кино -->
						<template v-if="isAreaHasShowWithName('Нейросетевое кино. Конкурсная программа')">
							<a class="mini_button" href="https://disk.yandex.ru/i/HONJ1w-G93S0ag" target="_blank">Нейросетевое кино, 35 мин, 18+ - Высокое качество</a>
							<a class="mini_button" href="https://disk.yandex.ru/i/skr4zZfKjm11HQ" target="_blank">Нейросетевое кино, 35 мин, 18+ - Быстрое скачивание</a>
						</template>
						
						<!-- Звёзды в коротком метре -->
						<template v-if="isAreaHasShowWithName('Звёзды в коротком метре. Игровое кино')">
							<a class="mini_button" href="https://disk.yandex.ru/i/cbTVYsYXikZrlw" target="_blank">Звёзды в коротком метре, 101 мин, 18+ - Высокое качество</a>
							<a class="mini_button" href="https://disk.yandex.ru/i/O3RWQdiTcSJH3Q" target="_blank">Звёзды в коротком метре, 101 мин, 18+ - Быстрое скачивание</a>
						</template>
						
						<!-- Программа Кинокампуса Киностудии Горького -->
						<template v-if="isAreaHasShowWithName('Специальная программа Кинокампуса Киностудии Горького. Игровое кино')">
							<a class="mini_button" href="https://disk.yandex.ru/i/Hceo_J3r3Djcqg" target="_blank">Программа киностудии Горького, 82 мин, 12+ - Высокое качество</a>
							<a class="mini_button" href="https://disk.yandex.ru/i/J_qYpjpdt1E0hQ" target="_blank">Программа киностудии Горького, 82 мин, 12+ - Быстрое скачивание</a>
						</template>
						
						<!-- Все только начинается -->
						<template v-if="isAreaHasShowWithName('Все только начинается. Документальное кино')">
							<a class="mini_button" href="https://disk.yandex.ru/i/6GlLuZk5vMpAYw" target="_blank">Все только начинается, 68 мин, 16+ - Высокое качество</a>
							<a class="mini_button" href="https://disk.yandex.ru/i/bIyTv2XP35yavw" target="_blank">Все только начинается, 68 мин, 16+ - Быстрое скачивание</a>
						</template>
					</template>
				</div>
				
				
				<div class="columns" style="margin-top: 30px;">
					<div class="column is-narrow" style="padding: 0; margin-right: 30px;">
						<div style="max-width: 300px;">
							<label style="margin-bottom: 7px; display: block">Дата и время показов</label>
							<!--              <Datepicker-->
							<!--                  v-model="show_date"-->
							<!--                  selectText="Выбрать"-->
							<!--                  cancelText="Отменить"-->
							<!--                  locale="ru-RU"-->
							<!--                  format="yyyy-MM-dd HH:mm:ss"-->
							<!--              ></Datepicker>-->
							
							<DatePicker
								v-model:value="show_date"
								:show-time="{ format: 'HH:mm' }"
								:show-second="false"
								format="YYYY-MM-DD HH:mm"
								:locale="locale"
							>
							</DatePicker>
						</div>
					</div>
					<div class="column" style="padding: 0;">
						<div>
							<label style="display: block; margin-bottom: 7px;">Выбрать программу</label>
							<div class="select-field" style="margin-top: 0;">
								<select v-model="show_programm" style="height: 55px; max-width: 300px">
									<template v-if="area2.country">
										
										
										<!--                    <template v-if="userid === '7194'">-->
										<!--                      <option value="РОССИЯ + СНГ">РОССИЯ + СНГ</option>-->
										<!--                    </template>-->
										<template v-if="area2.country !== 'Российская Федерация'">
											<option value="Шаг навстречу. Игровое кино">Step Forward, 92 min, 18+</option>
											<option value="Возвращение домой. Игровое кино">Homecoming, 87 min, 12+</option>
											<option value="Суздальфест: часть первая 6+">Suzdal-fest: pt.1, 76 min, 6+ (No subtitles)</option>
											<option value="Суздальфест: часть вторая 6+">Suzdal-fest: pt.2, 65 min, 6+ (No subtitles)</option>
											<option value="Документальное кино: часть первая">DOC, pt.1 78 min, 16+</option>
											<option value="Документальное кино: часть вторая">DOC, pt.2 81 min, 18+</option>
											<option value="Нейросетевое кино">AI-films, 35 min, 18+</option>
										
										</template>
										<template v-else>
											
											<option value="Суздальфест: часть первая 6+">Суздальфест: часть первая 6+</option>
											<option value="Суздальфест: часть вторая 6+">Суздальфест: часть вторая 6+</option>
											<option value="Нейросетевое кино. Конкурсная программа">Нейросетевое кино. Конкурсная программа
											</option>
											<option value="Звёзды в коротком метре. Игровое кино">Звёзды в коротком метре. Игровое кино
											</option>
											<option value="Специальная программа Кинокампуса Киностудии Горького. Игровое кино">Специальная
												программа Кинокампуса Киностудии Горького. Игровое кино
											</option>
											<option value="Все только начинается. Документальное кино">Все только начинается. Документальное
												кино
											</option>
										
										</template>
									</template>
								</select>
							</div>
						</div>
					</div>
				</div>
				<div class="field">
					<BaseOneChoiseCheckbox
						label='Хотим онлайн конференцию с авторами'
						v-model="show_is_online"
						fieldId="show_is_online"
						objectKey="show_is_online"
					></BaseOneChoiseCheckbox>
				</div>
				<p><a class="button2" @click="addDateTime">+ Добавить показ</a></p>
				
				<div v-if="area2.shows && area2.shows.length > 0">
					<p><strong>Показы</strong></p>
					<div class="table_wrapper">
						<table class="table">
							<tr>
								<td>Дата/время показа</td>
								<td>Конф-ция <a title="Нажмите галочку, если хотите провести онлайн встречу с авторами."
								                class="pulse">
									<FontAwesomeIcon style="cursor: pointer; color: green;"
									                 icon="question"></FontAwesomeIcon>
								</a></td>
								<td>Мест в зале <a title="Количество мест в зале" class="pulse">
									<FontAwesomeIcon style="cursor: pointer; color: green;"
									                 icon="question"></FontAwesomeIcon>
								</a></td>
								<td>Зрителей <a title="Укажите количество зрителей, присутствующих на этом показе"
								                class="pulse">
									<FontAwesomeIcon title="Количество зрителей на показе"
									                 style="cursor: pointer; color: green;"
									                 icon="question"></FontAwesomeIcon>
								</a></td>
								<td>Программа</td>
								<td>Загрузки</td>
								<td>Ссылки на релизы на сайтах</td>
								<td>Удалить показ</td>
							</tr>
							<template v-for="(show, index) in (area2?.shows || [])" :key="index">
								<tr v-if="isDateShowInRange(area2.shows[index].date)">
									<td>
										<!--                <Datepicker-->
										<!--                    v-model="area2.shows[index].date"-->
										<!--                    selectText="Выбрать"-->
										<!--                    cancelText="Отменить"-->
										<!--                    locale="ru-RU"-->
										<!--                    format="yyyy-MM-dd HH:mm:ss"-->
										<!--                    style="width: 215px"-->
										<!--                    @update:model-value="saveData"-->
										<!--                ></Datepicker>-->
<!--										v-model:value="area2.shows[index].date" @change="saveData"-->
										
										<DatePicker
											v-if="area2?.shows"
											:value="showDate(index)"
											:show-time="{ format: 'HH:mm' }"
											format="YYYY-MM-DD HH:mm"
											:locale="locale"
											@update:value="(val) => updateShowDate(index, val)"
										></DatePicker>
									
									</td>
									<td style="text-align: center">
										<BaseOneChoiseCheckbox @onChange="saveData" style="display: block"
										                       v-model="area2.shows[index].show_is_online"
										                       fieldId="show"></BaseOneChoiseCheckbox>
									</td>
									<td>{{ area2.hall_num }}</td>
									<td><input style="width: 50px" type="text" @change="saveData"
									           v-model="area2.shows[index].count_viewers">
									</td>
									<td style="width: 150px">{{ area2.shows[index].show_programm }}</td>
									<td>
										<!--                v-if="userid === '6368'"-->
										<p>
											<button style="width: 100px" @click="uploadPhotoHandler(index)">Фотографии с
												показа
											</button>
										</p>
										<p>
											<button style="width: 100px" @click="uploadScreenHandler(index)">Скриншоты
												публикаций
											</button>
										</p>
									</td>
									<td>
										<BaseTextarea
											style="margin-top: 0;"
											v-model="area2.shows[index].links"
											@change="saveData"
										></BaseTextarea>
									</td>
									<td style="text-align: center">
										<FontAwesomeIcon v-if="isCoordinator || isAdmin" style="cursor: pointer; color:red;font-size: 15px;"
										                 @click="deleteDatetime(index)"
										                 icon="trash"></FontAwesomeIcon>
									</td>
								</tr>
							</template>
						</table>
					</div>
				</div>
			</template>
			<template v-else>
				<h2 style="font-size: 23px;">Информация о показах</h2>
				<p style="font-size: 15px;">Доступно после сохранения площадки</p>
			</template>
			
			
			<p style="margin-bottom: 200px;"><a v-if="!area2id" class="button2"
			                                    @click="isSubmitted = true; checkErrors(); saveData();">Сохранить</a>
			</p>
		
		</div>
		
		<Modal wrapClassName="upload_block_area" v-model:visible="isPhotoUpload" title="Загрузка фотографий"
		       :footer="null" :destroyOnClose="true">
			<DropzoneComponent
				url="/upload_area_photo"
				getFilesUrl="/get_area_photos/"
				:currentId="this.area2id"
				:show="this.current_show"
				@onChange="getData()"
				type="photo"
			></DropzoneComponent>
		</Modal>
		
		<Modal wrapClassName="upload_block_area" v-model:visible="isScreenUpload" title="Загрузка скриншотов публикаций"
		       :footer="null"
		       :destroyOnClose="true">
			<DropzoneComponent
				url="/upload_area_screen"
				getFilesUrl="/get_area_screens/"
				:currentId="this.area2id"
				:show="this.current_show"
				@onChange="getData()"
				type="screen"
			/>
		</Modal>
	
	</div>
</template>

<style scoped>
.button2 {
	display: inline-block;
}

.table tr td {
	font-size: 11px;
}

.shows_items {
	font-size: 14px;
}

.shows_items > div {
	margin-bottom: 15px;
}

.shows_items .mini_button {
	padding: 5px;
}

.errors-block {
	color: red;
	border: 1px solid #999;
	border-radius: 10px;
	padding: 25px;
	margin-bottom: 30px;
}

.mini_button {
	padding: 10px;
	border: 2px solid #000;
	color: #000;
	margin-right: 15px;
	margin-bottom: 15px;
	font-size: 15px;
}

.ant-picker-dropdown {
	z-index: 9999;
}

.table_wrapper {
	position: relative;
	overflow-x: auto;
	width: 100%
}

@media (max-width: 1000px) {
	.modal {
		padding: 10px;
		margin: 10px;
	}
}
</style>